import PlatformActions from './listing/listing-platform-actions/platformActions';
import ListingsRowActions from './listing/listing-row-actions/listing-row-actions';
import ListingCard from './listing/listingCard';
import ListingsPage from './listing/ListingsPageGate';
import RecentListings from './listing/RecentListingsGate';
import PostListingPage from './post-listing/post-listing';
import AdLicensePage from './ad-license/create-ad-license';
import CreditInfoDrawer from './credit-info-drawer/creditInfoDrawer';
import QuotaInfoDrawer from './quota-info-drawer/quotaInfoDrawer';
import LocationSelect from './post-listing/location-select/location-select';
import PostListingWithPropertyType from './post-listing/post-listing-with-options';
import UpgradeListingPage from './upgrade-listing/upgrade-listing';
import ReportUnwantedContactModal from './report-unwanted-contact/report-unwanted-contact-modal';
import ActiveAdLicensesWidget from './ad-license-visibility/active-ad-licenses-widget';
import AdLicenseSearchInput from './ad-license-visibility/ad-license-search-input';
import AdLicenseBacklogCard from './ad-license-visibility/ad-license-backlog-card';
import { assignDefaultValueToObject } from '../../../utility/utility';
import { MobileNavBar } from './layout/mobileNavBar';

let Components = {
  PostListingPage,
  PlatformActions,
  ListingsRowActions,
  LocationSelect,
  CreditInfoDrawer,
  QuotaInfoDrawer,
  MobileNavBar,
  ListingsPage,
  RecentListings,
  UpgradeListingPage,
  ListingCard,
  PostListingWithPropertyType,
  AdLicensePage,
  ReportUnwantedContactModal,
  ActiveAdLicensesWidget,
  AdLicenseSearchInput,
  AdLicenseBacklogCard,
};

export default assignDefaultValueToObject(Components, () => null);
